import {Helmet} from 'react-helmet-async';
import React from 'react';
import {useHostName} from 'presentation/hooks/useHostName';
import {ProductEnum} from 'presentation/constants';

export const CookieLaw = () => {
	const {dataHostNameState} = useHostName();

	const cookieLawHash = {
		[ProductEnum.GNDI_MINAS]: 'e489b983-b451-435b-9eef-301dc239e75a',
		[ProductEnum.CLINIPAM]: '8839ab19-4136-486b-8632-c8aa0818d979',
		[ProductEnum.CCG]: '5517e3ef-00c6-458e-b74e-08da89c1542b',
		[ProductEnum.HAP]: '008e435c-a24e-46af-8988-a085f6d34188',
		[ProductEnum.GNDI]: '01937802-ee16-7bbe-8c6e-777fd7d3d273',
		[ProductEnum.NOTREDAME_SAUDE]: '01937802-ee16-7bbe-8c6e-777fd7d3d273',
	};

	return (
		<>
			<Helmet>
				<script
					src={`https://cdn.cookielaw.org/consent/${
						cookieLawHash[dataHostNameState.product]
					}/OtAutoBlock.js`}
					type="text/javascript"></script>
				<script
					src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
					data-domain-script={cookieLawHash[dataHostNameState.product]}
					type="text/javascript"></script>
			</Helmet>
		</>
	);
};
